import React from "react";

import { faChartPieSimple, faFolderOpen, faRectangleList } from "@fortawesome/pro-regular-svg-icons";

import { QuickActionCard } from "./QuickActionCard";

import type { SendQueryOptions } from "../../hooks/useAskStream";
import { useFormQuickActionEnabled } from "../../hooks/useFormQuickActionEnabled";

import { useAskPerformYardStore } from "../../AskPerformYardStore";

type AskPyEmptyStateProps = {
	/** Fires the card's query through the agent stream. AskPyPanel supplies this from its sendQuery. */
	onSelect: (options: SendQueryOptions) => void;
};

export const AskPyEmptyState: React.FC<AskPyEmptyStateProps> = ({ onSelect }) => {
	const askHrEnabled = useAskPerformYardStore((state) => state.cachedAskHrEnabled);
	const goalCreationEnabled = useAskPerformYardStore((state) => state.cachedGoalCreationEnabled);
	const hasNoDocuments = useAskPerformYardStore((state) => state.hasNoDocuments);
	// Read through the shared hook rather than the store's cached copy: the permission half of this
	// gate is only folded in by the container's greeting effect, which is invisible from here.
	const formCreationEnabled = useFormQuickActionEnabled();

	return (
		<div className="flex flex-1 flex-col gap-4 overflow-y-auto px-5 pt-6" data-testid="ask-py-empty-state">
			<h2 className="m-0 text-xl leading-8 font-semibold text-neutral-9">How can I help?</h2>
			{/* Anywhere-actions only (PY-14057) — page-contextual coach actions render as chips above the
			    panel's input, where AskPyPanel owns their gating. */}
			<div className="grid grid-cols-2 gap-3">
				{formCreationEnabled && (
					<QuickActionCard
						icon={faRectangleList}
						label="Help me build a review form"
						data-testid="ask-py-card-form"
						onClick={() => onSelect({ query: "Help me build a review form", agent: "form" })}
					/>
				)}
				{goalCreationEnabled && (
					<QuickActionCard
						icon={faChartPieSimple}
						label="Help me build a goal"
						data-testid="ask-py-card-goal"
						onClick={() => onSelect({ query: "Help me build a goal" })}
					/>
				)}
				{askHrEnabled && !hasNoDocuments && (
					<QuickActionCard
						icon={faFolderOpen}
						label="Tell me about my company documents"
						data-testid="ask-py-card-documents"
						onClick={() => onSelect({ query: "Tell me about my company documents" })}
					/>
				)}
			</div>
		</div>
	);
};

export default AskPyEmptyState;
